import {initializeApp} from 'firebase/app';
import {getMessaging} from 'firebase/messaging';

//Firebase Config values imported from .env file
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Messaging service — guarded because getMessaging throws in browsers
// that have notifications/Push API disabled (e.g. Edge with denied permissions).
let messagingInstance = null;
try {
  messagingInstance = getMessaging(app);
} catch (e) {
  console.warn('Firebase Messaging is not supported in this browser:', e);
}
export const messaging = messagingInstance;
